module.exports = __webpack_public_path__ + "img/icon23.5cf5b0eb.svg";